<template>
  <div class="community_explore">
    <div
      @click="CloseDrawer"
      size="medium"
      v-if="drawer && activeName == 'jrcode'"
      style="
                  position: fixed;
                  z-index: 10000;
                  float: left;
                  bottom: 0px;
                  right: 0px;
                  color: white;
                  border: 0px;
                "
    >
      <!--
      <svg style="position: fixed; bottom: 10px; right: 10px; cursor: pointer" t="1667367585021" class="icon"
        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="49889" width="45" height="45">
        <path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64z"
          fill="#FF934A" p-id="49890"></path>
        <path
          d="M498.56 519.666a10.668 10.668 0 0 1 0-15.332c21.718-21.126 84.97-82.904 148.374-147.128 14.336-14.516 19.86-35.152 7.744-51.408-4.972-6.654-11.584-14.192-20.352-22.284-11.926-11.014-23.296-18.38-32.768-23.28-15.51-8.02-33.686-3.928-47.766 6.24-110.25 79.572-185.43 165.484-221.802 211.612-15.98 20.29-15.98 47.538 0 67.828 36.372 46.128 111.552 132.04 221.802 211.614 14.08 10.166 32.256 14.256 47.766 6.238 9.472-4.9 20.842-12.266 32.768-23.28 8.768-8.092 15.38-15.63 20.352-22.284 12.116-16.256 6.592-36.892-7.744-51.406-63.404-64.226-126.656-126.004-148.374-147.13z"
          fill="#FFFFFF" p-id="49891"></path>
      </svg>
      -->

      <el-image
        style="width: 45px; height: 45px"
        src="https://wugecdn.steam.fun/resources/jrcode/back3.png"
        fit="fit"
      ></el-image>
    </div>

    <div
      @click="CloseDrawer"
      size="medium"
      v-if="drawer && activeName == 'scratch'"
      style="
              position: fixed;
              z-index: 10000;
              /* float: left; */
              top: 0px;
              /* right: 10px; */
              /* padding: 20px; */
              border: 0px;
              height: 50px;
                "
    >
      <span
        style="position: fixed; padding:5px 15px; border-radius:5px; top:10px; right: 10px; font-size: 14px; cursor: pointer; background: #e9f1fc;"
        >返回社区</span
      >
    </div>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <div class="swiper">
            <el-carousel :interval="5000" arrow="never" :height="autoHeight">
              <el-carousel-item v-for="item of bannerList" :key="item.id">
                <el-row>
                  <el-col :span="24">
                    <div class="wrapper">
                      <el-image
                        class="swiper-img"
                        :src="item.img_url"
                      ></el-image>
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-col>
    </el-row>

    <div style="width: 100%; background: #f9f9f9">
      <el-row style="max-width: 1200px; margin: 0px auto">
        <el-col :span="24">
          <div class="coursetype">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-if="jr_show" label="Jrcode" name="jrcode">
                <el-row>
                  <el-col :span="12">
                    <div class="grid-content bg-purple"></div>

                    <el-radio-group
                      v-model="form.tag_id"
                      size="mini"
                      @change="getZoneFindMoreWorkList"
                    >
                      <el-radio-button label="">全部</el-radio-button>

                      <el-radio-button
                        v-for="item of TagData"
                        :key="item.id"
                        style="margin-left: 5px"
                        :label="item.code"
                        >{{ item.name }}</el-radio-button
                      >
                    </el-radio-group>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <el-row style="text-align: right">
                        <el-col :span="14">
                          <div class="grid-content bg-purple">
                            <el-input
                              placeholder="请输入作品的名称"
                              v-model="form.title"
                              size="mini"
                              @keyup.enter.native="search"
                            >
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="grid-content bg-purple-light">
                            <el-button
                              @click="search"
                              style="margin-left: 5px"
                              size="mini"
                              icon="el-icon-search"
                            >
                            </el-button>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <!-- <el-col :span="24"> -->
                          <div class="grid-content bg-purple-light">
                            <el-radio-group
                              size="mini"
                              v-model="form.search_value"
                              @change="getZoneFindMoreWorkList"
                            >
                              <el-radio-button label="1">最新</el-radio-button>
                              <el-radio-button label="2">精选</el-radio-button>
                              <el-radio-button label="3">最热</el-radio-button>
                            </el-radio-group>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                    <div class="chosen_wrapper">
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <div class="chosen_content">
                            <el-row>
                              <el-col :span="24">
                                <div>
                                  <el-row :gutter="20">
                                    <el-col
                                      style="margin-bottom: 20px"
                                      :span="25"
                                      v-for="item of workList"
                                      :key="item.id"
                                    >
                                      <el-card shadow="hover">
                                        <div class="worklist">
                                          <div
                                            class="worklist_imgwrapper"
                                            @click="LookWork(item)"
                                          >
                                            <el-image
                                              class="workimg"
                                              :src="item.covers"
                                              fit="fill"
                                            ></el-image>
                                          </div>

                                          <div class="work_title">
                                            <span class="work_title_span">{{
                                              item.title
                                            }}</span>
                                            <br />

                                            <span
                                              style="margin: 5px"
                                              class="el-icon-thumb"
                                            >
                                              <span style="margin: 5px">{{
                                                item.zan
                                              }}</span>
                                            </span>
                                            <span
                                              style="margin: 5px"
                                              class="el-icon-view"
                                              ><span style="margin: 5px">{{
                                                item.looks
                                              }}</span></span
                                            >
                                          </div>

                                          <div>
                                            <el-row>
                                              <el-col :span="4">
                                                <div class="work_stuinfo">
                                                  <el-avatar
                                                    size="small"
                                                    class="work_stuinfo_avatar"
                                                    :src="item.headImgUrl"
                                                  ></el-avatar>
                                                </div>
                                              </el-col>
                                              <el-col :span="12">
                                                <div class="work_stuinfo_name">
                                                  <span
                                                    class="
                                                                work_stuinfo_name_span
                                                              "
                                                    >{{ item.name }}</span
                                                  >
                                                </div>
                                              </el-col>
                                            </el-row>
                                          </div>
                                        </div>
                                      </el-card>
                                    </el-col>
                                  </el-row>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>

                <div style="margin: 20px; text-align: center">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="page_no"
                    :page-size="page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="sc_show" label="Scratch" name="scratch">
                <el-row>
                  <el-col :span="12">
                    <div class="grid-content bg-purple"></div>

                    <el-radio-group
                      v-model="form.tag_id"
                      size="mini"
                      @change="getZoneFindMoreWorkList"
                    >
                      <el-radio-button label="">全部</el-radio-button>

                      <el-radio-button
                        v-for="item of TagData"
                        :key="item.id"
                        style="margin-left: 5px"
                        :label="item.code"
                        >{{ item.name }}</el-radio-button
                      >
                    </el-radio-group>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <el-row style="text-align: right">
                        <el-col :span="14">
                          <div class="grid-content bg-purple">
                            <el-input
                              placeholder="请输入作品的名称"
                              v-model="form.title"
                              size="mini"
                              @keyup.enter.native="search"
                            >
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="grid-content bg-purple-light">
                            <el-button
                              @click="getZoneFindMoreWorkList"
                              style="margin-left: 5px"
                              size="mini"
                              icon="el-icon-search"
                            ></el-button>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <!-- <el-col :span="24"> -->
                          <div class="grid-content bg-purple-light">
                            <el-radio-group
                              size="mini"
                              v-model="form.search_value"
                              @change="getZoneFindMoreWorkList"
                            >
                              <el-radio-button label="1">最新</el-radio-button>
                              <el-radio-button label="2">精选</el-radio-button>
                              <el-radio-button label="3">最热</el-radio-button>
                            </el-radio-group>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                    <div class="chosen_wrapper">
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <div class="chosen_content">
                            <el-row>
                              <el-col :span="24">
                                <div>
                                  <el-row :gutter="20">
                                    <el-col
                                      style="margin-bottom: 20px"
                                      :span="25"
                                      v-for="item of workList"
                                      :key="item.id"
                                    >
                                      <el-card shadow="hover">
                                        <div class="worklist">
                                          <div
                                            class="worklist_imgwrapper"
                                            @click="LookWork(item)"
                                          >
                                            <el-image
                                              class="workimg"
                                              :src="item.covers"
                                              fit="fill"
                                            ></el-image>
                                          </div>

                                          <div class="work_title">
                                            <span class="work_title_span">{{
                                              item.title
                                            }}</span>
                                            <br />

                                            <span
                                              style="margin: 5px"
                                              class="el-icon-thumb"
                                            >
                                              <span style="margin: 5px">{{
                                                item.zan
                                              }}</span>
                                            </span>
                                            <span
                                              style="margin: 5px"
                                              class="el-icon-view"
                                              ><span style="margin: 5px">{{
                                                item.looks
                                              }}</span></span
                                            >
                                          </div>

                                          <div>
                                            <el-row>
                                              <el-col :span="4">
                                                <div class="work_stuinfo">
                                                  <el-avatar
                                                    size="small"
                                                    class="work_stuinfo_avatar"
                                                    :src="item.headImgUrl"
                                                  ></el-avatar>
                                                </div>
                                              </el-col>
                                              <el-col :span="12">
                                                <div class="work_stuinfo_name">
                                                  <span
                                                    class="
                                                                work_stuinfo_name_span
                                                              "
                                                    >{{ item.name }}</span
                                                  >
                                                </div>
                                              </el-col>
                                            </el-row>
                                          </div>
                                        </div>
                                      </el-card>
                                    </el-col>
                                  </el-row>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>

                <div style="margin: 20px; text-align: center">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="page_no"
                    :page-size="page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>

              <el-tab-pane v-if="python_show" label="Python" name="python">
                <el-row>
                  <el-col :span="12">
                    <div class="grid-content bg-purple"></div>

                    <el-radio-group
                      v-model="form.tag_id"
                      size="mini"
                      @change="getZoneFindMoreWorkList"
                    >
                      <el-radio-button label="">全部</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple-light">
                      <el-row style="text-align: right">
                        <el-col :span="14">
                          <div class="grid-content bg-purple">
                            <el-input
                              placeholder="请输入作品的名称"
                              v-model="form.title"
                              size="mini"
                              @keyup.enter.native="search"
                            >
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="grid-content bg-purple-light">
                            <el-button
                              @click="getZoneFindMoreWorkList"
                              style="margin-left: 5px"
                              size="mini"
                              icon="el-icon-search"
                            ></el-button>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <!-- <el-col :span="24"> -->
                          <div class="grid-content bg-purple-light">
                            <el-radio-group
                              size="mini"
                              v-model="form.search_value"
                              @change="getZoneFindMoreWorkList"
                            >
                              <el-radio-button label="1">最新</el-radio-button>
                              <el-radio-button label="2">精选</el-radio-button>
                              <el-radio-button label="3">最热</el-radio-button>
                            </el-radio-group>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                    <div class="chosen_wrapper">
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <div class="chosen_content">
                            <el-row>
                              <el-col :span="24">
                                <div>
                                  <el-row :gutter="20">
                                    <el-col
                                      style="margin-bottom: 20px"
                                      :span="25"
                                      v-for="item of workList"
                                      :key="item.id"
                                    >
                                      <el-card shadow="hover">
                                        <div class="worklist">
                                          <div
                                            class="worklist_imgwrapper"
                                            @click="LookWork(item)"
                                          >
                                            <el-image
                                              class="workimg"
                                              :src="item.covers"
                                              fit="fill"
                                            ></el-image>
                                          </div>

                                          <div class="work_title">
                                            <span class="work_title_span">{{
                                              item.title
                                            }}</span>
                                            <br />

                                            <span
                                              style="margin: 5px"
                                              class="el-icon-thumb"
                                            >
                                              <span style="margin: 5px">{{
                                                item.zan
                                              }}</span>
                                            </span>
                                            <span
                                              style="margin: 5px"
                                              class="el-icon-view"
                                              ><span style="margin: 5px">{{
                                                item.looks
                                              }}</span></span
                                            >
                                          </div>

                                          <div>
                                            <el-row>
                                              <el-col :span="4">
                                                <div class="work_stuinfo">
                                                  <el-avatar
                                                    size="small"
                                                    class="work_stuinfo_avatar"
                                                    :src="item.headImgUrl"
                                                  ></el-avatar>
                                                </div>
                                              </el-col>
                                              <el-col :span="12">
                                                <div class="work_stuinfo_name">
                                                  <span
                                                    class="
                                                                work_stuinfo_name_span
                                                              "
                                                    >{{ item.name }}</span
                                                  >
                                                </div>
                                              </el-col>
                                            </el-row>
                                          </div>
                                        </div>
                                      </el-card>
                                    </el-col>
                                  </el-row>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>

                <div style="margin: 20px; text-align: center">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="page_no"
                    :page-size="page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="cplus_show" label="C++" name="cplus"
                >C++</el-tab-pane
              >
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <communityheader></communityheader>
    <communityfooter></communityfooter>

    <el-drawer
      :with-header="false"
      title="查看作品(点击右上角X号退出)"
      size="100%"
      :visible.sync="drawer"
      direction="ltr"
      :destroy-on-close="false"
    >
      <iframe
        style="background:#F9F9F9;"
        id="iframe_project1"
        width="100%"
        height="100%"
        :src="project_url"
      ></iframe>
    </el-drawer>
  </div>
</template>

<script>
import communityheader from "./header";
import communityfooter from "./footer";

import {
  getZoneFindMoreWorkList,
  zoneGetZoneBannerList,
  updateScWorkLooks,
  updateJrWorkLooks,
  updatePyWorkLooks,
} from "@/api/community";
import { getSchoolSubjectList } from "@/api/educational";

import { getWorkTagList } from "@/api/community";

export default {
  name: "community-explore",
  components: {
    communityheader,
    communityfooter,
  },
  data() {
    return {
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      labelPosition: "1",
      value1: true,
      value2: true,
      value: [],
      activeName: "",
      subject_code: "",
      subjectList: [],
      jr_show: false,
      sc_show: false,
      python_show: false,
      cplus_show: false,
      //作品搜索条件
      form: {
        title: "",
        search_value: "1",
        tag_id: "",
      },
      workList: [], //作品列表
      page_no: 1,
      page_size: 40,
      total: 0,

      TagData: [], //社区标签

      bannerList: [], //社区轮播图
      autoHeight: "0px", //轮播图自适应高度

      drawer: false,
      project_url: "",
    };
  },

  mounted() {
    this.getAutoHeight();
    this.getSchoolSubjectList();
    this.zoneGetZoneBannerList();
  },
  activated() {
    document.getElementById("home_top").style.display = "none";
  },

  methods: {
    //增加作品浏览量
    updateScWorkLooks(id) {
      updateScWorkLooks({
        work_id: id,
      }).then((res) => {
        console.log("增加作品浏览量");
        console.log(res);
      });
    },

    //增加作品浏览量
    updateJrWorkLooks(id) {
      updateJrWorkLooks({
        work_id: id,
      }).then((res) => {
        console.log("增加作品浏览量");
        console.log(res);
      });
    },

    //增加作品浏览量
    updatePyWorkLooks(id) {
      updatePyWorkLooks({
        work_id: id,
      }).then((res) => {
        console.log("增加作品浏览量");
        console.log(res);
      });
    },

    CloseDrawer() {
      this.drawer = false;
    },

    //轮播图自适应高度
    getAutoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      this.autoHeight = _w * 0.196 + "px";
    },

    //查询校区科目权限
    getSchoolSubjectList() {
      getSchoolSubjectList().then((res) => {
        console.log("获得校区科目列表");
        console.log(res);
        this.subjectList = res.subjectList;

        for (let k = 0; k < res.subjectList.length; k++) {
          if (res.subjectList[k].code == "1") {
            this.jr_show = true;
          } else if (res.subjectList[k].code == "2") {
            this.sc_show = true;
          } else if (res.subjectList[k].code == "3") {
            this.python_show = true;
          } else if (res.subjectList[k].code == "4") {
            console.log("暂未开放");
            //this.cplus_show = true;
          }
        }

        this.subject_code = res.subjectList[0].code;
        if (this.subject_code == "1") {
          this.activeName = "jrcode";
        } else if (this.subject_code == "2") {
          this.activeName = "scratch";
          this.getWorkTagList();
        } else if (this.subject_code == "3") {
          this.activeName = "python";
        } else if (this.subject_code == "4") {
          //this.activeName = "cplus";
          console.log("暂未开放");
        }
        this.getZoneFindMoreWorkList();
      });
    },

    //获得社区轮播图
    zoneGetZoneBannerList() {
      zoneGetZoneBannerList().then((res) => {
        console.log("获取校区轮播图");
        console.log(res);
        this.bannerList = res.bannerList;
      });
    },

    //查询标签列表
    getWorkTagList() {
      getWorkTagList().then((res) => {
        console.log("查询标签列表");
        console.log(res);
        this.TagData = res.work_tag_list;
      });
    },
    search() {
      this.page_no = 1;
      this.getZoneFindMoreWorkList();
    },

    //社区更多作品
    getZoneFindMoreWorkList() {
      console.log("搜索参数");
      console.log(this.form);
      console.log(this.subject_code);
      getZoneFindMoreWorkList({
        subject_code: this.subject_code,
        page_no: this.page_no,
        page_size: this.page_size,
        title: this.form.title,
        search_value: this.form.search_value,
        tag_id: this.form.tag_id,
      }).then((res) => {
        console.log("社区发现更多作品");
        console.log(res);
        this.workList = res.workList;
        this.total = res.total;
      });
    },

    //跳转到作品详情页面
    //跳转到作品详情页面
    LookWork(item) {
      console.log("跳转到作品详情页面");
      console.log(item);

      if (this.subject_code == "2") {
        this.drawer = true;
        this.project_url =
          "/community/project?work_id=" +
          item.id +
          "&subject_code=" +
          this.subject_code;

        this.updateScWorkLooks(item.id);
      } else if (this.subject_code == "1") {
        this.drawer = true;

        this.project_url =
          "/jrcode/teashow.html?mode=look&filepath=" + item.work_url;

        this.updateJrWorkLooks(item.id);
      } else if (this.subject_code == "3") {
        console.log("python自由创作作品");
        if (localStorage.getItem("current_py_version")) {
          if (localStorage.getItem("current_py_version") == "v2") {
            this.$router.push({
              name: "python_editor_v2",
              query: {
                work_id: item.id,
                mode: "look",
              },
            });
          } else if (localStorage.getItem("current_py_version") == "v1") {
            this.$router.push({
              name: "python_editor",
              query: {
                work_id: item.id,
                mode: "look",
              },
            });
          }
        } else {
          this.$router.push({
            name: "python_editor_v2",
            query: {
              work_id: item.id,
              mode: "look",
            },
          });
        }

        this.updatePyWorkLooks(item.id);
      }
    },

    handleClick(tab, event) {
      console.log(tab, event);
      if (this.activeName == "jrcode") {
        this.subject_code = "1";
        this.page_no = 1;
        this.TagData = [];
        this.getZoneFindMoreWorkList();
      } else if (this.activeName == "scratch") {
        this.subject_code = "2";
        this.page_no = 1;
        this.getZoneFindMoreWorkList();
        this.getWorkTagList();
      } else if (this.activeName == "python") {
        this.subject_code = "3";
        this.page_no = 1;
        this.TagData = [];
        this.getZoneFindMoreWorkList();
      }
    },

    handleCurrentChange(val) {
      this.page_no = val;
      this.getZoneFindMoreWorkList();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .swiper-img {
    width: 100%;
    object-fit: fill;
  }
}

.coursetype {
  padding: 20px;
  background: #f9f9f9;
  min-height: 60vh;
}

.worktype {
  text-align: center;
  height: 40px;
  line-height: 40px;
  background: #f9f9f9;
}

.pagenum {
  text-align: center;
}

.chosen_wrapper {
  padding-top: 20px;

  .chosen_title {
    font-size: 20px;
    padding-bottom: 15px;
  }

  .chosen_student {
    font-size: 20px;
  }

  .chosen_content {
    .el-col-25 {
      width: 20%;
    }

    .worklist {
      background: white;
      border-radius: 5px;

      .worklist_imgwrapper {
        width: 100%;
        height: 0;
        padding-bottom: 75%;
        cursor: pointer;

        .workimg {
          width: 100%;
          border-radius: 5px 5px 0 0;
        }
      }

      .work_title {
        padding-top: 10px;

        .work_title_span {
          width: 90%;
          overflow: hidden;
          /*内容超出后隐藏*/
          text-overflow: ellipsis;
          /* 超出内容显示为省略号 */
          white-space: nowrap;
          /* 文本不进行换行 */

          // display: -webkit-box; /*值必须为-webkit-box或者-webkit-inline-box*/
          // -webkit-box-orient: vertical; /*值必须为vertical*/
          // -webkit-line-clamp: 1; /*值为数字，表示一共显示几行*/

          margin-left: 5px;
          font-size: 14px;
          color: #333333;
          font-weight: bold;
        }
      }

      .work_stuinfo {
        .work_stuinfo_avatar {
          float: left;
          margin: 5px;
        }
      }

      .work_stuinfo_name {
        .work_stuinfo_name_span {
          line-height: 40px;
          margin: 5px;
        }
      }
    }
  }

  .chosen_student_list {
    padding-bottom: 20px;
  }
}

.student_wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 49.5%;

  border-bottom: 1px solid rgb(172, 167, 167);

  .img_wrapper {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;
    margin-top: 25%;

    .student_img {
      width: 100%;
      object-fit: fill;

      border-radius: 10px;
    }
  }

  .stu_info_wrapper {
    padding-left: 10px;
    margin-top: 15%;
  }
}
</style>
<style>
.community_explore .el-card__body {
  padding: 0px;
}
</style>
